const footerData = [
  {
    heading: 'Product',
    links: [
      {
        label: 'Home',
        href: '/',
        trackingLabel: 'homepage',
      },
      {
        label: 'Platform Features',
        href: '/product',
        trackingLabel: 'product-features-overview',
      },
      {
        label: 'Pricing',
        href: '/pricing',
        trackingLabel: 'pricing-nav',
      },
      {
        label: 'Video Hosting',
        href: '/product/hosting',
        trackingLabel: 'product-hosting',
      },
      {
        label: 'Webinar Hosting',
        href: '/product/webinar-hosting',
        trackingLabel: 'product-webinar-hosting',
      },
      {
        label: 'Video Recording',
        href: '/product/video-recording',
        trackingLabel: 'product-recording',
      },
      {
        label: 'Video Editing',
        href: '/product/video-editing',
        trackingLabel: 'product-editing',
      },
      {
        label: 'AI Video Editing',
        href: '/product/remix-ai-video-editor',
        trackingLabel: 'product-ai-video-editing',
      },
      {
        label: 'Video Analytics',
        href: '/product/analytics',
        trackingLabel: 'product-analytics',
      },
      {
        label: 'Embedding',
        href: '/product/embeds',
        trackingLabel: 'product-embedding',
      },
      {
        label: 'Ad-free Player',
        href: '/product/player',
        trackingLabel: 'product-ad-free-player',
      },
      {
        label: 'Collections',
        href: '/product/collections',
        trackingLabel: 'product-collections',
      },
      {
        label: 'Channels',
        href: '/product/channels',
        trackingLabel: 'product-galleries',
      },
      {
        label: 'Localization',
        href: '/product/localize',
        trackingLabel: 'product-localization',
      },
      {
        label: 'Marketing Automation',
        href: '/product/marketing-automation',
        trackingLabel: 'product-marketing-automation',
      },
      {
        label: 'Lead Generation',
        href: '/product/lead-generation',
        trackingLabel: 'product-lead-generation',
      },
      {
        label: 'SEO',
        href: '/product/video-seo',
        trackingLabel: 'product-seo',
      },
      {
        label: 'Engagement',
        href: '/product/interactive-video',
        trackingLabel: 'product-engagement',
      },
      {
        label: 'Wistia API',
        href: '/product/platform',
        trackingLabel: 'product-platform',
      },
      {
        label: 'Collaboration',
        href: '/product/collaboration',
        trackingLabel: 'product-collaboration',
      },
      {
        label: 'Accessibility',
        href: '/product/accessibility',
        trackingLabel: 'product-accessibility',
      },
      {
        label: 'Video Podcasts',
        href: '/product/podcasting',
        trackingLabel: 'product-podcasting',
      },
      {
        label: 'Enterprise Video Platform',
        href: '/product/enterprise-video-platform',
        trackingLabel: 'product-enterprise-video-platform',
      },
      {
        label: 'Wistia For Video Professionals',
        href: '/explore/wistia-for-video-professionals',
        trackingLabel: 'product-wistia-for-video-professionals',
      },
    ],
  },
  {
    heading: 'Learning Center',
    links: [
      {
        label: 'Blog',
        href: '/learn',
        trackingLabel: 'learning-center-blog',
      },
      {
        label: 'Events',
        href: '/events',
        trackingLabel: 'learning-center-webinars',
      },
      {
        label: 'Customer Stories',
        href: '/learn/showcase',
        trackingLabel: 'learning-center-customer-stories',
      },
      {
        label: 'Guide to Video Marketing',
        href: '/about/video-marketing-guide',
        trackingLabel: 'learning-center-guide-to-video-marketing',
      },
      {
        label: 'State of Video Report',
        href: '/explore/state-of-video-report',
        trackingLabel: 'learning-center-state-of-video-2025',
      },
      {
        label: 'AI Video Marketing Trends',
        href: '/explore/ai-video-trends',
        trackingLabel: 'learning-center-ai-video-trends',
      },
      {
        label: 'The Video Repurposing Cookbook',
        href: '/explore/video-repurposing-cookbook',
        trackingLabel: 'learning-center-video-repurposing-cookbook',
      },
      {
        label: 'Wistia Webinar Guidebook',
        href: '/webinarwizard',
        trackingLabel: 'learning-center-webinar-guidebook',
      },
      {
        label: 'Asset Library',
        href: '/resources/free-downloads',
        trackingLabel: 'learning-center-asset-library',
      },
    ],
  },
  {
    heading: 'Video Series',
    links: [
      {
        label: 'Talking Too Loud',
        href: '/series/talking-too-loud',
        trackingLabel: 'series-talking-too-loud',
      },
      {
        label: 'Fix My Setup',
        href: '/for/fix-my-setup',
        trackingLabel: 'series-fix-my-setup',
      },
      {
        label: 'Show Business',
        href: '/show-business/episodes',
        trackingLabel: 'series-show-business',
      },
      {
        label: 'Brandwagon',
        href: '/series/brandwagon',
        trackingLabel: 'series-brandwagon',
      },
      {
        label: 'Gear Squad vs Dr. Boring',
        href: '/series/gear-squad',
        trackingLabel: 'series-gear-squad',
      },
      {
        label: 'A Better Workplace',
        href: '/series/a-better-workplace',
        trackingLabel: 'series-a-better-workplace',
      },
      {
        label: 'One, Ten, One Hundred',
        href: '/series/one-ten-one-hundred',
        trackingLabel: 'series-one-ten-one-hundred',
      },
    ],
  },
  {
    heading: 'Support',
    links: [
      {
        label: 'Help Center',
        href: '/support',
        trackingLabel: 'learning-center-help-center',
      },
      {
        label: 'Developer Docs',
        href: 'https://docs.wistia.com/',
        trackingLabel: 'learning-center-developer-docs',
      },
      {
        label: 'Product Changelog',
        href: 'https://updates.wistia.com/',
        trackingLabel: 'learning-center-product-changelog',
      },
      {
        label: 'Status',
        href: 'https://status.wistia.com/',
        trackingLabel: 'learning-center-status',
      },
      {
        label: 'Contact Support',
        href: '/support/contact',
        trackingLabel: 'learning-center-contact-support',
      },
    ],
  },
  {
    heading: 'Company',
    links: [
      {
        label: 'About Us',
        href: '/about',
        trackingLabel: 'about-us',
      },
      {
        label: 'Brand Assets',
        href: '/about/assets',
        trackingLabel: 'brand-assets',
      },
      {
        label: 'Careers',
        href: '/jobs',
        trackingLabel: 'careers',
      },
      {
        label: 'Company Values',
        href: '/about/values',
        trackingLabel: 'company-values',
      },
      {
        label: 'DEI & Belonging',
        href: '/about/diversity-equity-inclusion-belonging',
        trackingLabel: 'dei-belonging',
      },
      {
        label: 'Partner Program',
        href: '/partner-program',
        trackingLabel: 'partner-program',
      },
      {
        label: 'Security',
        href: 'https://security.wistia.com/',
        trackingLabel: 'security',
      },
      {
        label: 'AI Policy & Governance',
        href: '/privacy-ai',
        trackingLabel: 'ai-policy-governance',
      },
    ],
  },
];

export default footerData;
